export enum BrandHomepageLayout {
    Categories = 'categories',
    Events = 'events',
    Widget = 'widget'
}
